
      import ExportList from './export-list.vue'
      import type { App, Plugin } from 'vue'

      export const ExportListPlugin: Plugin = {
        install(app: App) {
          app.component('ExportList', ExportList)
        },
      }
      export { ExportList }
      